<template>
  <div>
    <v-btn-toggle class="toggle-column">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" elevation="4">
            <v-icon color="#3FA0A5">mdi-arrow-right-circle-outline</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group>
            <v-list-item @click="moveToSelect(2)">
              <v-list-item-title>{{
                currentLanguage == "ru"
                  ? string_values.find((x) => x.value == "to_market").nameRu
                  : string_values.find((x) => x.value == "to_market").nameEn
              }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="moveToSelect(1)">
              <v-list-item-title>{{
                currentLanguage == "ru"
                  ? string_values.find((x) => x.value == "to_view").nameRu
                  : string_values.find((x) => x.value == "to_view").nameEn
              }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="moveToSelect(2); moveToSelect(1);">
              <v-list-item-title>{{
                currentLanguage == "ru"
                  ? string_values.find((x) => x.value == "to_market_view").nameRu
                  : string_values.find((x) => x.value == "to_market_view").nameEn
              }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
      <v-btn @click="deleteCatalogItems()" elevation="4">
        <v-icon color="red">mdi-arrow-left-circle-outline</v-icon>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import { string_values } from "../../../assets/strings/string_values";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CatalogAction",
  data: () => ({
    userReportId: 0,
    string_values: string_values,
    currentLanguage: "ru",
  }),
  computed: {
    ...mapGetters({
      getSelectedCatalogItems: "catalog/GET_SELECTED_CATALOG_ITEMS",
      getAddedCatalogItemsCount: "userReport/GET_ADD_CATALOG_ITEMS_COUNT",
      getSelectedDeleteCatalogItems:
        "catalog/GET_SELECTED_DELETE_CATALOG_ITEMS",
      getDeletedCatalogItemsCount: "userReport/GET_DELETED_CATALOG_ITEMS_COUNT",
      getCatalogRequestConfigs: "config/GET_CATALOG_REQUEST_CONFIGS",
      getAtcIds: "item/GET_ATC_ID",
    }),
    selectedCatalogItems() {
      return this.getSelectedCatalogItems;
    },
    addedCatalogItemsCount() {
      return this.getAddedCatalogItemsCount;
    },
    selectedDeleteCatalogItems() {
      return this.getSelectedDeleteCatalogItems;
    },
    deletedCatalogItemsCount() {
      return this.getDeletedCatalogItemsCount;
    },
    catalogRequestConfigs() {
      return this.getCatalogRequestConfigs;
    },
    atcIds() {
      return this.getAtcIds;
    },
  },
  methods: {
    ...mapActions({
      addCatalogItems: "userReport/ADD_CATALOG_ITEMS",
      getUserReportById: "userReport/GET_USER_REPORT_BY_ID",
      deleteCatalogItemsFromAPI: "userReport/DELETE_CATALOG_ITEMS",
      generateSnackbar: "snackbar/GENERATE_SNACKBAR",
      getIdsByATCCode: "item/GET_ID_BY_ATC_CODE",
    }),
    async moveToSelect(type) {
      if (this.selectedCatalogItems.List.length > 0) {
        this.userReportId = parseInt(this.$route.params.id, 10);
        var resultSelectedCatalogItems = this.selectedCatalogItems;
        var catalogItem = this.catalogRequestConfigs.find(
          (x) =>
            x.catalogRequestTypeId == 1001 &&
            x.catalogId == resultSelectedCatalogItems.List[0].catalogId
        );
        var reportId = this.userReportId;
        if (catalogItem != undefined) {
          var resultStr = "";
          resultSelectedCatalogItems.List.map((x) => x.value).forEach(function (
            val
          ) {
            resultStr += catalogItem.currentCatalogID + val;
          });
          var query = catalogItem.url + catalogItem.query + resultStr;
          await this.getIdsByATCCode(query);

          var selectedItemsArr = [];
          this.atcIds.data.forEach(function (value) {
            selectedItemsArr.push({
              userReportId: reportId,
              catalogId: catalogItem.catalogId,
              value: value,
              userReportCatalogTypeId: type,
            });
          });
          resultSelectedCatalogItems.List = selectedItemsArr;
          await this.addCatalogItems(resultSelectedCatalogItems);
        } else {
          resultSelectedCatalogItems.List = resultSelectedCatalogItems.List.map(
            function (x) {
              return {
                catalogId: x.catalogId,
                userReportId: x.userReportId,
                value: x.value,
                userReportCatalogTypeId: type,
              };
            }
          );
          await this.addCatalogItems(resultSelectedCatalogItems);
        }
        if (this.addedCatalogItemsCount.data > 0) {
          await this.getUserReportById({
            userReportId: this.userReportId,
          });
          console.log(this.selectedCatalogItems);
        } else {
          this.generateSnackbar({
            show: true,
            timeout: 3000,
            color: "red",
            text:
              this.currentLanguage == "ru"
                ? this.string_values.find((x) => x.value == "error_message")
                    .nameRu
                : this.string_values.find((x) => x.value == "error_message")
                    .nameEn,
          });
        }
      } else {
        this.generateSnackbar({
          show: true,
          timeout: 3000,
          color: "red",
          text:
            this.currentLanguage == "ru"
              ? this.string_values.find((x) => x.value == "error_message")
                  .nameRu
              : this.string_values.find((x) => x.value == "error_message")
                  .nameEn,
        });
      }
    },
    async deleteCatalogItems() {
      if (this.selectedDeleteCatalogItems.length > 0) {
        this.userReportId = parseInt(this.$route.params.id, 10);
        await this.deleteCatalogItemsFromAPI(this.selectedDeleteCatalogItems);
        if (this.deletedCatalogItemsCount.data > 0)
          await this.getUserReportById({
            userReportId: this.userReportId,
          });
        else
          this.generateSnackbar({
            show: true,
            timeout: 3000,
            color: "red",
            text:
              this.currentLanguage == "ru"
                ? this.string_values.find((x) => x.value == "error_message")
                    .nameRu
                : this.string_values.find((x) => x.value == "error_message")
                    .nameEn,
          });
      } else {
        this.generateSnackbar({
          show: true,
          timeout: 3000,
          color: "red",
          text:
            this.currentLanguage == "ru"
              ? this.string_values.find((x) => x.value == "error_message")
                  .nameRu
              : this.string_values.find((x) => x.value == "error_message")
                  .nameEn,
        });
      }
    },
  },
  mounted() {
    var currentLanguage = localStorage.getItem("currentLanguage");
    if (currentLanguage != null) {
      this.currentLanguage = currentLanguage;
    } else {
      localStorage.setItem("currentLanguage", "ru");
    }
  },
};
</script>

<style scoped>
.toggle-column {
  flex-direction: column;
}
</style>
